import React from 'react';
import { Link } from 'react-router-dom';
import BlogArticleLayout, { blogStyles as s } from './BlogArticleLayout';

function BlogArticleIARGPDNIS2Articuler() {
  return (
    <BlogArticleLayout
      tag="IA & Cybersécurité"
      title="IA, RGPD, NIS2 : comment articuler les trois exigences"
      date="7 janvier 2027"
      ctaTitle="Traitez l'IA dans votre diagnostic global de conformité"
      ctaText="Le diagnostic couvre RGPD, NIS2, ISO 27001 et l'IA dans une seule démarche, plutôt que quatre chantiers séparés."
    >
      <p style={s.intro}>
        Une entreprise qui utilise l'IA ne fait pas face à un référentiel supplémentaire isolé : elle voit ses
        obligations RGPD et NIS2 existantes s'appliquer différemment dès lors que l'IA entre dans l'équation,
        en plus de l'AI Act qui s'y ajoute spécifiquement.
      </p>

      <h2 style={s.h2}>Le RGPD s'applique dès qu'une IA traite des données personnelles</h2>
      <p>
        Si un système d'IA traite des données personnelles — ce qui est fréquent dès qu'il s'agit
        d'assistance client, de recrutement ou d'analyse de comportement — les obligations RGPD habituelles
        s'appliquent pleinement : base légale, information des personnes, sécurité du traitement, et
        limitation de la conservation. Voir notre
        {' '}<Link to="/blog/rgpd-cybersecurite-ce-que-toute-entreprise-doit-savoir" style={s.link}>guide RGPD</Link>{' '}
        pour ces obligations générales.
      </p>

      <h2 style={s.h2}>NIS2 et la résilience des systèmes qui intègrent de l'IA</h2>
      <p>
        Pour une entreprise concernée par NIS2, un système d'IA intégré à ses réseaux et systèmes
        d'information entre dans le périmètre de gestion des risques imposé par la directive, au même titre
        que n'importe quel autre système critique — voir notre article
        {' '}<Link to="/blog/nis2-pme-ce-qui-change" style={s.link}>NIS2 pour les PME : ce qui change concrètement</Link>.
      </p>

      <h2 style={s.h2}>L'AI Act, un texte spécifique qui s'ajoute</h2>
      <p>
        L'AI Act ne remplace ni le RGPD ni NIS2 : il introduit des obligations propres aux systèmes d'IA
        eux-mêmes, en particulier pour les usages à risque élevé — voir notre
        {' '}<Link to="/blog/ai-act-cybersecurite-entreprise" style={s.link}>article dédié à l'AI Act</Link>.
      </p>

      <h2 style={s.h2}>Une seule cartographie, trois grilles de lecture</h2>
      <p>
        Plutôt que de traiter ces textes séparément, l'approche la plus efficace consiste à partir d'une seule
        cartographie de vos usages de l'IA et de vos données, puis à l'examiner successivement à travers
        chaque grille réglementaire. C'est la même logique que celle qui sous-tend notre article pivot
        {' '}<Link to="/blog/rgpd-nis2-iso27001-differences" style={s.link}>RGPD, NIS2, ISO 27001 : quelles différences ?</Link>,
        étendue ici à l'IA.
      </p>

      <p style={s.disclaimer}>
        Cet article a une vocation informative et ne remplace pas une analyse juridique personnalisée par un
        professionnel du droit ou votre DPO.
      </p>
    </BlogArticleLayout>
  );
}

export default BlogArticleIARGPDNIS2Articuler;
